// dependencies
import React from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";

// components
import Field from "@cloudspire/legacy-resources/src/components/Field";
import Stack from "@cloudspire/legacy-resources/src/components/Stack";
import {
  DiscountCodeInput,
  DiscountCodeList,
} from "@cloudspire/legacy-resources/src/components/Booking/DiscountCode";

function BookingDiscountCodeListContainer(props) {
  const { parameterList, bookingEstimateResponse, errorList, onChange } = props;

  const intl = useIntl();

  const loading =
    (!bookingEstimateResponse.data && !bookingEstimateResponse.error) ||
    bookingEstimateResponse.isValidating;

  return (
    <>
      <Field
        label={intl.formatMessage({
          defaultMessage: "Je profite du code promo",
        })}
      >
        <DiscountCodeInput
          name="discountCodeList"
          loading={loading}
          parameterList={parameterList}
          onChange={onChange}
        />
      </Field>
      {parameterList?.discountCodeList?.length > 0 && (
        <>
          <Stack marginTop={1} />

          <DiscountCodeList
            name="discountCodeList"
            parameterList={parameterList}
            bookingEstimateResponse={bookingEstimateResponse}
            errorList={errorList}
            onChange={onChange}
          />
        </>
      )}
    </>
  );
}

BookingDiscountCodeListContainer.propTypes = {
  bookingEstimateResponse: PropTypes.object,
  parameterList: PropTypes.object,
  errorList: PropTypes.object,
  onChange: PropTypes.func,
};

export default BookingDiscountCodeListContainer;
